
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"13","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1140_3709)","fill":"#8B969D"}},[_c('path',{attrs:{"d":"M6.5 0A6.5 6.5 0 1013 6.5 6.507 6.507 0 006.5 0zm0 11.917A5.417 5.417 0 1111.917 6.5 5.423 5.423 0 016.5 11.917z"}}),_c('path',{attrs:{"d":"M6.5 5.417h-.542a.542.542 0 100 1.083H6.5v3.25a.542.542 0 001.083 0V6.5A1.083 1.083 0 006.5 5.417zM6.5 4.333a.812.812 0 100-1.625.812.812 0 000 1.625z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1140_3709"}},[_c('rect',{attrs:{"width":"13","height":"13","fill":"#fff"}})])])])
          )
        }
      }
    